 <template>
  <div class="topic">
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              :no-data-text-data.sync="noDataText"
              @on-refresh="onRefresh"
              @on-infinite="onInfinite"
              class="my_scroller"
              ref="my_scroller"

    >
      <div class="list">
        <topic-list-comp v-for="(item, index) of list" :topicItem="item" :key="index"></topic-list-comp>
      </div>
    </Scroller>
  </div>
</template>

<script>
import Scroller from '../common/Scroller'
import communityItem from '../common/communityItem'
import topicListComp from '../common/topicListComp'
import { isWeixin, fenxiang } from '../../assets/common/js/config'

export default {
  name: 'topicList',
  components: {
    Scroller,
    communityItem,
    topicListComp
  },
  data: function () {
    return {
      list: [],
      nowPage: 0,
      refresh: false,
      loading: false,
      finished: false,
      noDataText: '————\n客官，么有啦~\n————'
    }
  },
  mounted: function () {
    this.pagesize = 20
  },
  beforeRouteEnter (to, from, next) {
    if (!sessionStorage.askPositon || (from.path == '/' && from.name != 'homePage')) { // 当前页面刷新不需要切换位置
      sessionStorage.askPositon = ''
      next(vm => {
        if (isWeixin()) fenxiang({path: 'topiclist'})
      })
    } else {
      next(vm => {
        if (isWeixin()) fenxiang({path: 'topiclist'})
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    next()
  },
  methods: {
    getData: function () {
      var that = this
      var url = this.$ajax.getAllTopic_UTL
      url= url + '?pageno=' + this.nowPage + '&pagesize=' + this.pagesize
      this.$customRequestAjax(url)
        .then(function (res) {
          if (res.data.code == 200) {
            let list = []
            list = res.data.list
            if (that.nowPage === 1) {
              that.list = list
              that.refresh = false
            } else {
              that.list = that.list.concat(list)
            }
            that.loading = false
            that.finished = list.length < that.pagesize
          }
        })
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      that.nowPage++
      that.getData()
    }
  }
}
</script>

<style scoped lang="scss">
  .topic {
    background: #fff;
  }
  .list {
    width: 100%;
    padding-right: 0.1rem;
    padding-top: 0.1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/community/topicList.vue